var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-total" },
    [
      _c("div", { staticClass: "outer row no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("message.subtotal")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col text-right" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.getNumber(_vm.subTotalNumber)) + "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "outer row no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("message.discounts")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col text-right" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.getNumber(_vm.discountNumber)) + "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.taxes, function(tax, index) {
        return _c("div", { key: index, staticClass: "outer row no-margin" }, [
          _c("div", { staticClass: "col" }, [
            _vm._v("\n      " + _vm._s(tax.displayText) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col text-right" }, [
            _vm._v("\n      " + _vm._s(_vm.getNumber(tax.total)) + "\n    ")
          ])
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "outer row no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("message.total")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col text-right" }, [
          _vm._v("\n      " + _vm._s(_vm.getNumber(_vm.totalNumber)) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _vm.disabled == "false"
        ? _c(
            "button",
            {
              staticClass: "btn-pay btn btn-web col",
              class: [_vm.btnPaymentDisabled],
              staticStyle: { "margin-top": "8px" },
              on: {
                click: function($event) {
                  return _vm.onClickPayment()
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.currencyFormatter(_vm.totalNumber, {
                      code: _vm.currency
                    })
                  ) +
                  "\n    "
              ),
              _vm.btnPaymentDisabled == "disabled" && _vm.orders.length > 0
                ? _c("i", { staticClass: "fas fa-spinner spin" })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.disabled == "true"
        ? _c("div", { staticClass: "outer row no-margin" }, [
            _c(
              "div",
              {
                staticClass: "col text-right",
                staticStyle: { "font-size": "32px", "font-weight": "bold" }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.currencyFormatter(_vm.totalNumber, {
                        code: _vm.currency
                      })
                    ) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcfa765a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcfa765a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/TotalPrice.vue
// module id = null
// module chunks = 